import type { Visit } from '../domain/story'

/** Entries trigger attempts; elapsed time alone never triggers delivery. */
export class AutomaticDecisionCycle {
  private entry = 0
  private attempted: string | null = null
  private lastAttemptAt: number | null = null

  enter() {
    this.entry += 1
  }
  reset() {
    this.entry = 0
    this.attempted = null
    this.lastAttemptAt = null
  }

  attempt(visit: Visit, now: number): boolean {
    const seconds = visit.recommendationRetryAfterSeconds
    const cycle = `${visit.id}:${visit.dayEndsAt}${seconds ? `:${this.entry}` : ''}`
    if (this.attempted === cycle) return false
    this.attempted = cycle
    if (
      seconds &&
      this.lastAttemptAt !== null &&
      now < this.lastAttemptAt + seconds * 1000
    )
      return false
    this.lastAttemptAt = now
    return true
  }
}
